module.exports = {"credits":"جهان گستر پارس"}